import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AdminURL } from "../../routes/admin_routes/AdminURL";
import { useAuth } from "../../utils/AuthContext";
import "../../css/components/page_wrappers/admin/Sidebar.css";

const Sidebar = () => {
    const { logout } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const menuItems = [
        { label: "Home", path: AdminURL.ADMIN_DASHBOARD },
        { label: "Users", path: AdminURL.ADMIN_USERS },
        { label: "All Invoices", path: AdminURL.ADMIN_ALL_INVOICES },
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <div className="admin-sidebar">
            {/* Top section */}
            <div>
                {menuItems.map((item) => (
                    <button
                        key={item.path}
                        onClick={() => navigate(item.path)}
                        className={`admin-sidebar-button ${isActive(item.path) ? "admin-sidebar-button-active" : ""}`}
                    >
                        {item.label}
                    </button>
                ))}
            </div>

            {/* Bottom section */}
            <div>
                <button onClick={ logout } className="admin-logout-button">
                    Log Out
                </button>
            </div>
        </div>
    );
};

const AdminPageWrapper = ({ children }) => {
    return (
        <div style={{ display: "flex", margin: "0", padding: "0" }}>
            <Sidebar />
            <div style={{ marginLeft: "220px", padding: "20px", width: "100%" }}>
                {children}
            </div>
        </div>
    );
};

export default AdminPageWrapper;
